import React, { useState } from 'react'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline'

interface CollapsibleCardProps {
  title: string
  subtitle?: string
  icon?: React.ReactNode
  defaultOpen?: boolean
  className?: string
  headerClassName?: string
  // Tighter header/body padding and smaller title/chevron — for dense
  // layouts (e.g. the Job Overview tab's Skills/Experience/Education/Quality/
  // Matching cards) where the default p-6/text-lg sizing is too spacious.
  compact?: boolean
  children: React.ReactNode
}

const CollapsibleCard: React.FC<CollapsibleCardProps> = ({
  title,
  subtitle,
  icon,
  defaultOpen = false,
  className = '',
  headerClassName = '',
  compact = false,
  children
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(defaultOpen)

  return (
    <div className={`bg-white border border-gray-200 rounded-lg overflow-hidden ${className}`}>
      <button
        type="button"
        onClick={() => setIsOpen((v) => !v)}
        className={`w-full text-left border-b border-gray-200 flex items-start justify-between hover:bg-gray-50 ${compact ? 'px-3 py-2' : 'px-6 py-4'} ${headerClassName}`}
        aria-expanded={isOpen}
      >
        <div className="pr-4">
          <div className={`flex items-center ${compact ? 'space-x-1.5' : 'space-x-2'}`}>
            {icon}
            <h4 className={compact ? 'text-sm font-medium text-gray-900' : 'text-lg font-semibold text-gray-900'}>{title}</h4>
          </div>
          {subtitle && <p className="text-sm text-gray-600 mt-1">{subtitle}</p>}
        </div>
        <div className="mt-1 flex-shrink-0 text-gray-500">
          {isOpen ? (
            <ChevronUpIcon className={compact ? 'w-4 h-4' : 'w-5 h-5'} />
          ) : (
            <ChevronDownIcon className={compact ? 'w-4 h-4' : 'w-5 h-5'} />
          )}
        </div>
      </button>
      {isOpen && <div className={compact ? 'p-3' : 'p-6'}>{children}</div>}
    </div>
  )
}

export default CollapsibleCard


